export const ADDING = 'adding'
export const REMOVING = 'removing'
export const NO_CHANGE = 'no_change'

export const ALL_LEASE_CELLAR_CHANGES = [ADDING, REMOVING, NO_CHANGE] as const

export type LeaseCellarChange = (typeof ALL_LEASE_CELLAR_CHANGES)[number]
